import { maskitoPhoneOptionsGenerator } from '@maskito/phone'
import { useEffect, useState } from 'react'
import { MaskitoOptions } from '@maskito/core'

export const getPhoneMask = async () =>
    maskitoPhoneOptionsGenerator({
        metadata: (await import('libphonenumber-js/max/metadata')).default,
        strict: false,
        countryIsoCode: 'US',
    })

export const usePhoneMask = () => {
    const [options, setOptions] = useState<MaskitoOptions>()
    useEffect(() => {
        ;(async () => setOptions(await getPhoneMask()))()
    }, [])
    return options
}
